import * as React from "react";
function SvgIcTarget(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.351 6.356l-4.675 4.61-4.213-4.153-1.329 2.329a4.964 4.964 0 00-1.074-.136l2.18-3.819 4.436 4.374 3.973-3.917.702.712zM7.107 10.901L5.746 9.51l-4.137 5.179.782.624 3.43-4.295.731.747a4.98 4.98 0 01.555-.863zm10.014 8.322l-.687.687-2.866-2.867a3.97 3.97 0 01-.546.39c-.014.009-.03.016-.044.024a3.956 3.956 0 01-.557.27c-.072.03-.15.046-.224.07-.148.047-.294.098-.448.127A3.866 3.866 0 0111 18a4 4 0 114-4c0 .248-.029.488-.073.723-.018.097-.046.19-.07.285a3.935 3.935 0 01-.265.72c-.038.079-.08.154-.123.229-.074.13-.147.259-.234.38l2.886 2.886zM14 14c0-1.654-1.346-3-3-3s-3 1.346-3 3 1.346 3 3 3 3-1.346 3-3z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcTarget;
